import { Table } from "@mantine/core";
import React from "react";

export default function AssetTableGenerator({ DataObject, title }) {
  return (
    <Table verticalSpacing="xs" highlightOnHover withBorder>
      <thead>
        <tr style={{ background: "black" }}>
          <th colSpan="4" style={{ color: "white" }}>{title}</th>
        </tr>
        <tr key={"header"}>
          {Object.keys(DataObject[0]).map((key) => (
            <th>{key}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {DataObject.map((item) => (
          <tr key={item.id}>
            {Object.values(item).map((val) => (
              <td>
                <span style={{ marginLeft: 12 }}>{val}</span>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
